export const formatStatusEnum = (status: string) => {
  return (
    status.substring(0, 1).toUpperCase() +
    status.substring(1).toLowerCase()
  );
};
